import React, {useState} from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text, Box, CircularProgress, Table, Thead, Tr, Th, Tbody, Td, TableContainer, Flex
} from '@chakra-ui/react';
import {event} from "../../../../services/analytics";
import {useInboxLog} from "../../../../data/inbox-log";
import {formatDistanceToNow} from 'date-fns'
import {IconLink} from "../../atoms/IconLink";
import {DatabaseInfo} from "@app/core-app/app/data/notion/DatabaseInfo";

function InboxLogComponent({ databaseId, database }) {
  const { data, isLoading, isValidating } = useInboxLog(databaseId);

  const databaseObj = database as DatabaseInfo
  return (
    <TableContainer>
      <Table variant="simple" size="sm">
        <Thead>
          <Tr>
            <Th>No.</Th>
            <Th>Email Subject</Th>
            <Th textAlign={"center"}>Open</Th>
            <Th>Time Since Received</Th>
            <Th>Status</Th>
            <Th>Error Message</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data && data.map((log, index) => (
            <Tr key={log.emailId}>
              <Td>{index+1}</Td>
              <Td maxW={"md"} overflow={"hidden"}>{log.emailSubject || 'No Subject'}</Td>
              <Td>
                {log.pageId &&
                  <Flex justifyContent={"center"} alignItems={"center"}>
                    <IconLink url={databaseObj.url + "?p=" + log?.pageId?.replace(/-/g, "") + "&pm=s"}/>
                  </Flex>
                }
              </Td>
              <Td>{formatDistanceToNow(new Date(log.timestamp), { addSuffix: true })}</Td>

              <Td>
                <Box color={log.status === 'ok' ? 'green.500' : 'red.500'}>
                  {log.status === 'ok' ? 'Saved' : 'Error'}
                </Box>
              </Td>

              <Td color={log.errorMessage ? 'red.500' : 'green.500'}>
                {log.errorMessage || ''}
              </Td>
            </Tr>
          ))}
          {(isLoading || isValidating) && (
            <Tr>
              <Td colSpan={6}>
                <CircularProgress isIndeterminate size="24px" />
              </Td>
            </Tr>
          )}
          {data && !isLoading && !isValidating && data.length === 0 && (
            <Tr>
              <Td colSpan={6} py={4} fontSize={"base"} lineHeight={"lg"}>
                <Text>No saved email records are found.</Text>
                <Text>Send new email to the Notion database address to save your email to the database.</Text>
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </TableContainer>
  );
}

function InboxLogModal({isOpen, onClose, databaseId, database}: any) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"5xl"} scrollBehavior={"inside"}>
      <ModalOverlay/>
      <ModalContent minH={"75vh"}>
        <ModalHeader>Saved Emails</ModalHeader>
        <ModalCloseButton/>
        <ModalBody>
          <InboxLogComponent databaseId={databaseId} database={database}/>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export function ViewInboxLogButton({databaseId, database}: { databaseId: string, database: DatabaseInfo }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    event({action: "open_inbox_log_modal", params: {databaseId}})
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button size="sm" colorScheme="blue" onClick={handleOpenModal} variant={"outline"}>
        <span>View Saved Emails</span>
      </Button>
      <InboxLogModal isOpen={isOpen} onClose={handleCloseModal} databaseId={databaseId} database={database}/>
    </>
  );
}
